import React from "react";
import { Link } from "react-router-dom";
import Navigation from "../Components/Navigation";
import "../Components/Css/Home.css";
import Footer from "./Footer";
const Home = () => {
  const HomeSection = () => {
    return (
      <section className="home">
        <div className="homecontainer">
          <div className="container-text">
            <h1>A RESTful Ben10 API</h1>
            <h2>Get all Ben10 Aliens data</h2>
            <h3>
              Powered by{" "}
              <span className="tech">
                <a href="https://nodejs.org/en/">NodeJS</a>
              </span>
              ,
              <span className="tech">
                <a href="https://expressjs.com/">Express</a>
              </span>
              &nbsp;&&nbsp;
              <span className="tech">
                <a href="https://www.mongodb.com/">MongoDB</a>
              </span>
            </h3>
            <Link to="/docs">
              <button className="button">Get Started &nbsp;→</button>
            </Link>
          </div>
        </div>
      </section>
    );
  };
  return (
    <div>
      <Navigation />
      {HomeSection()}
      <Footer />
    </div>
  );
};

export default Home;
